import cryptoUtils from '../utils/utils';

const CHECKSUM_HASH_LENGTH = 4;

function isValidP0Address(address, currency, opts) {
    const match = address.toLowerCase().match(/^f0[0-9]{1,20}$/);
    if (match == null) {
        return false;
    }

    return true;
}

function isValidP1Address(address, currency, opts) {
    const match = address.toLowerCase().match(/^f1[0-9a-zA-Z]+$/);
    if (match === null) {
        return false;
    }

    return testChecksum(address, 1);
}

function isValidP2Address(address, currency, opts) {
    const match = address.toLowerCase().match(/^f2[0-9a-zA-Z]{39}$/);
    if (match === null) {
        return false;
    }

    return testChecksum(address, 2);
}

function isValidP3Address(address, currency, opts) {
    const match = address.toLowerCase().match(/^f3[0-9a-zA-Z]{84}$/);
    if (match === null) {
        return false;
    }

    return testChecksum(address, 3);
}

function testChecksum(address, protocol) {
    // Based on:
    // https://github.com/filecoin-project/go-address/blob/f2023ef3f5BBC513599a3fbf19c4770485146a07/address.go#L318-L338
    const payloadChecksum = cryptoUtils.base32.b32decode(address.slice(2).toUpperCase());

    if (payloadChecksum.length - CHECKSUM_HASH_LENGTH < 0) {
        return false;
    }

    const checksumIndex = payloadChecksum.length - CHECKSUM_HASH_LENGTH;
    const payload = payloadChecksum.slice(0, checksumIndex);
    const checksum = cryptoUtils
        .byteArray2hexStr(payloadChecksum.slice(checksumIndex))
        .toLowerCase();

    const hash_payload = new Uint8Array(payload.length + 1);
    hash_payload[0] = protocol;
    hash_payload.set(payload, 1);
    const calcChecksum = cryptoUtils.blake2b(hash_payload, CHECKSUM_HASH_LENGTH);
    return calcChecksum === checksum;
}

export default {
    isValidAddress(address, currency, opts = {}) {
        const match = address.match(/^.([0-3])/);

        if (match === null) {
            return false;
        }

        const protocol = match[1];

        switch (protocol) {
        case '0':
            return isValidP0Address(address, currency, opts);
        case '1':
            return isValidP1Address(address, currency, opts);
        case '2':
            return isValidP2Address(address, currency, opts);
        case '3':
            return isValidP3Address(address, currency, opts);
        }
    },
};
